const carouselGalleriesSelector = ({ homeState }) => homeState.carouselGalleries

export {
    carouselGalleriesSelector
}